import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';

import {
  aranoxDarkTheme,
  aranoxLightTheme,
} from '../../design-system';

const aranoxLightThemeExtension = ThemeBlueprint.make({
  name: 'aranox-light',
  params: {
    theme: {
      id: 'aranox-light',
      title: 'ARANOX Claro',
      variant: 'light',
      icon: <Brightness7Icon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={aranoxLightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const aranoxDarkThemeExtension = ThemeBlueprint.make({
  name: 'aranox-dark',
  params: {
    theme: {
      id: 'aranox-dark',
      title: 'ARANOX Escuro',
      variant: 'dark',
      icon: <Brightness4Icon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={aranoxDarkTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    aranoxLightThemeExtension,
    aranoxDarkThemeExtension,
  ],
});
